import ProductDetailsActionTypes from 'yoda-site-components/lib/actionTypes/ProductDetailsActionTypes';

const getProductActionobject = {
    type: ProductDetailsActionTypes.PRODUCTDETAILS_GET_REQUEST,
    payload: {},
};
export default [getProductActionobject];
